module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt20 ovh"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.brandList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "brandName",
      "label": "品牌中文名称",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "brandEnname",
      "label": "品牌英文名称",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryName",
      "label": "经营品类",
      "align": "center",
      "min-width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.supplierApplyBrandCategories), function(category) {
          return _c('p', [_vm._v(_vm._s(category.category.grandName) + "-" + _vm._s(category.category.parentName) + "-" + _vm._s(category.category.childrenName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "statusDesc",
      "label": "审核状态",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.openDetail(scope.row.brandApplyId)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507951e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplier/brandList.vue
// module id = 526
// module chunks = 0